import { useSearchParams } from 'react-router-dom';
import { CheckCircle2, XCircle } from 'lucide-react';

/**
 * Where a customer's phone lands after paying at the counter by QR code
 * (Stripe Checkout's success and cancel pages). Public: the customer has no
 * account. It shows nothing about the order beyond the number they paid for;
 * the counter screen has already said it was paid.
 */
function CounterPaid() {
  const [params] = useSearchParams();
  const cancelled = params.get('cancelled') === '1';
  const order = params.get('order');

  return (
    <div className="min-h-screen bg-neutral-50 flex items-center justify-center px-4">
      <div className="bg-white border border-neutral-200 rounded-2xl shadow-sm p-8 max-w-sm w-full text-center space-y-3">
        {cancelled ? (
          <>
            <XCircle className="h-12 w-12 text-neutral-400 mx-auto" />
            <h1 className="text-xl font-semibold text-neutral-900">Not paid</h1>
            <p className="text-sm text-neutral-600 break-words">Nothing was taken. Scan the code at the counter again to pay.</p>
          </>
        ) : (
          <>
            <CheckCircle2 className="h-12 w-12 text-green-600 mx-auto" />
            <h1 className="text-xl font-semibold text-neutral-900">Paid, thank you</h1>
            <p className="text-sm text-neutral-600 break-words">
              {order ? `Order ${order} is paid.` : 'Your order is paid.'} You can show this screen at the counter.
            </p>
          </>
        )}
      </div>
    </div>
  );
}

export default CounterPaid;
